import React, {useState, useEffect} from 'react';
import parse from "html-react-parser";

import Loading from "../../../Components/Common/Loading";
import useProductDetails from "../../../hooks/useProductDetails";
import ProductDetailsTable from "./ProductDetailsTable";
import useProductPriceList from "../../../hooks/useProductPriceList";
import useProductStockList from "../../../hooks/useProductStockList";
import {StockItemsContext} from "../../../Contexts/StockItemsContext";

const ProductTableWrapper = (
    {
        productGroupHeadings,
        productGroupTitle,
        selectVersion,
        urlIconCar,
        productGroupIdActive,
        contactDetails
    }
) => {
    const productsGroupIdList = productGroupHeadings.map((item) => item.data.id);
    const defaultProductGroupId = productGroupIdActive ? productGroupIdActive : productsGroupIdList[0];
    const [productGroupId, setProductGroupId] = useState(getInitialProductGroupId(productsGroupIdList, defaultProductGroupId));
    const {productDetails, loadingProductDetails} = useProductDetails(productGroupId, productGroupHeadings);

    const {
        productPriceList, loadingPriceList
    } = useProductPriceList(productGroupId, productDetails, productDetails?.show_specials ?? false);

    const productList = productDetails?.data_table?.body ? productDetails.data_table.body : [];
    const {
        productStockList, loadingStockList
    } = useProductStockList(productGroupId, productList, productDetails?.show_specials ?? false);

    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash.replace('#', '');
            if (hash) {
                const hashId = Number.parseInt(hash);
                if (productsGroupIdList.includes(hashId) && hashId !== productGroupId) {
                    setProductGroupId(hashId);
                }
            } else {
                if (productGroupId !== defaultProductGroupId) {
                    setProductGroupId(defaultProductGroupId);
                }
            }
        };

        window.addEventListener('hashchange', handleHashChange);

        if (!window.location.hash && productGroupIdActive && productGroupIdActive !== defaultProductGroupId) {
            window.location.hash = `#${productGroupIdActive}`;
        }

        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, [productGroupId, defaultProductGroupId, productGroupIdActive, productsGroupIdList]);

    const handleProductGroupIdChange = (newProductGroupId) => {
        setProductGroupId(newProductGroupId);

        if (newProductGroupId !== defaultProductGroupId) {
            window.location.hash = `#${newProductGroupId}`;
        } else {
            if (window.location.hash) {
                history.pushState("", document.title, window.location.pathname + window.location.search);
            }
        }
    };

    return (
        <StockItemsContext.Provider value={{
            productStockList,
            loadingStockList,
        }}>
            <div className="row mt-4 print-hide d-lg-none">
                <div className="col">
                    {productsGroupIdList.length > 1 && (
                        <h3 className="mb-2 font-weight-bold text-primary">{selectVersion}</h3>
                    )}
                </div>
            </div>
            {productsGroupIdList.length > 1 ? (
                <SelectProductGroup
                    productGroupId={productGroupId}
                    setProductGroupId={handleProductGroupIdChange}
                    options={productGroupHeadings}
                    defaultProductGroupId={defaultProductGroupId}
                />
            ) : (productGroupTitle ?
                <h3 className="mt-4 mb-4 text-color-base stop-page-break">{productGroupTitle}</h3> : null)}
            <div className="table-list js-table-list table-product-container">
                {loadingProductDetails ? <Loading/> : null}
                {loadingProductDetails || !productDetails || !productDetails?.data_table ?
                    null :
                    <ProductDetailsTable
                        productDetails={productDetails}
                        productPriceList={productPriceList}
                        loadingPriceList={loadingPriceList}
                        urlIconCar={urlIconCar}
                        contactDetails={contactDetails}
                    />
                }
            </div>
        </StockItemsContext.Provider>
    )
}

const SelectProductGroup = ({productGroupId, setProductGroupId, options, defaultProductGroupId}) => {
    const handleChange = (e) => {
        const productGroupIdNew = Number.parseInt(e.target.value);
        setProductGroupId(productGroupIdNew);
    }

    return (
        <div className="input-section input-select-white mb-5 product-detail-table">
            <div className="error-label"></div>
            <div className="custom-select-alt__wrapper">
                <select
                    className="position-absolute custom-select w-100"
                    value={productGroupId}
                    onChange={handleChange}
                >
                    {Object.values(options).map((item) => (
                        <option
                            key={item.data.id}
                            value={item.data.id}
                        >{parse(replaceSup(item.title))}</option>
                    ))}
                </select>
                <div className="custom-select-alt__trigger text-uppercase ml-auto">
                <span className="trigger__item" id="basic-addon1">
                    <div className="trigger__item__text">
                        Selecteer een uitvoering
                    </div>
                    <img
                        alt={'arrow down white'}
                        className="trigger__item__image"
                        src="/images/arrow-down-white.svg"
                    />
                </span>
                </div>
            </div>
        </div>
    )
}

const replaceSup = (str) => {
    return str.replace('<sup>', '').replace('</sup>', '');
}

const getInitialProductGroupId = (productsGroupIdList, defaultProductGroupId) => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
        const hashId = Number.parseInt(hash);
        if (productsGroupIdList.includes(hashId)) {
            return hashId;
        }
    }
    return defaultProductGroupId;
};


export default ProductTableWrapper;